import React, { useRef } from "react";
import { DatePicker, DatePickerProvider } from "@origin-digital/ods-pickers";

interface FormDatePickerProps {
  id: string;
  label: string;
  value: Date | string | null | undefined;
  onChange: (date: Date | null) => void;
  shouldDisableDate?: (date: Date) => boolean;
  helperText?: string;
  error?: boolean;
}

export const DatePickerWrapper: React.FC<FormDatePickerProps> = ({
  id,
  label,
  value,
  onChange,
  shouldDisableDate,
  helperText,
  error,
}) => {
  const datePickerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={datePickerRef}>
      <DatePickerProvider>
        <DatePicker
          id={id}
          label={label}
          muiProps={{
            slotProps: {
              textField: {
                variant: "outlined",
              },
              popper: {
                disablePortal: true,
                anchorEl: datePickerRef.current,
              },
            },
          }}
          onChange={onChange}
          value={value}
          shouldDisableDate={shouldDisableDate}
          helperText={helperText}
          error={error}
        />
      </DatePickerProvider>
    </div>
  );
};
